/**
 * LE callback SERA JOUé UNE FOIS QUE L'EVENEMENT SERA ARRETé (un delay en mili secondes plus tard)
 * @param delay    (number)   :
 * @param callback (function) :
 *
 **/
export function debounce(delay, callback) {
    let timer = null;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            callback(...args);
        }, delay);
    };
}
/* export function debounce(delay, callback) {
    let timer = null;
    return function () {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, delay);
    };
} */


/**
 * LE callback SERA JOUé TOUTES LES <delay> MILISECONDES
 * @param delay    (number)   :
 * @param callback (function) :
 *
 **/
export function throttle(delay, callback) {
    let last;
    let timer;
    return function () {
        let now = +new Date();
        let context = this;
        let args = arguments;
        if (last && now < last + delay) {
            // le délai n'est pas écoulé on reset le timer
            clearTimeout(timer);
            timer = setTimeout(function () {
                callback.apply(context, args);
                last = now;
            }, delay);
        } else {
            callback.apply(context, args);
            last = now;
        }
    };
}
